import { render } from "./CreatePost.vue?vue&type=template&id=69d0bf6e&scoped=true"
import script from "./CreatePost.vue?vue&type=script&lang=js"
export * from "./CreatePost.vue?vue&type=script&lang=js"

import "./CreatePost.vue?vue&type=style&index=0&id=69d0bf6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d0bf6e"]])

export default __exports__